/* global I18n */

import class_names from "classnames"
import {TooltipPortal} from "./tooltip"
import React, {useState} from "react"

const PerspectiveIcon = ({perspective, tooltip_placement}) => {
  const [perspective_element, set_perspective_element] = useState(null)
  return (
    <div className="perspective" ref={set_perspective_element}>
      <div className={class_names("perspective-image", perspective)}>
      </div>
      <TooltipPortal target={perspective_element} placement={tooltip_placement}>
        {I18n.t(`js.perspectives.${perspective}`)}
      </TooltipPortal>
    </div>
  )
}

export default PerspectiveIcon
